export const BAR_GRAPH_DEFAULT_STACKED_COLORS = [ 'primary-1', 'primary' ];
